module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-customer/manage-customer.component.css
// module id = ./src/app/manage-customer/manage-customer.component.css
// module chunks = main